import React from 'react';

// Foto em WebP com o PNG original como alternativa.
const Photo = ({ webp, png, alt, className, loading = 'lazy' }) => (
  <picture>
    <source srcSet={webp} type="image/webp" />
    <img src={png} alt={alt} className={className} loading={loading} decoding="async" />
  </picture>
);

export default Photo;
